import { render, staticRenderFns } from "./I18nMessageTypeManager.vue?vue&type=template&id=b2a4c42c&scoped=true&"
import script from "./I18nMessageTypeManager.vue?vue&type=script&lang=js&"
export * from "./I18nMessageTypeManager.vue?vue&type=script&lang=js&"
import style0 from "./I18nMessageTypeManager.vue?vue&type=style&index=0&id=b2a4c42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a4c42c",
  null
  
)

export default component.exports